import { render, staticRenderFns } from "./KnownFor.vue?vue&type=template&id=05d58798"
import script from "./KnownFor.vue?vue&type=script&setup=true&lang=js"
export * from "./KnownFor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KnownFor.vue?vue&type=style&index=0&id=05d58798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports